import React from 'react';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
//helpers
import { detailTypeProductRedirect } from 'helpers';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';

const ItemSlider = (props) => {
  const { assignedLibrary} = useAssignedLibrary();

  const urlRedirectLink = (item) => {
    if (item.outer_url !== '') {
      return `${item.outer_url}`;
    } else {
      return detailTypeProductRedirect(item.product, assignedLibrary);
    }
  };

  return (
    <>
      <div className="itemCarrousel">
        <div className="containerFileItem">
          {/* {props.item.type_rsc === 1 ? (   //No eliminar
            props.item.resource.indexOf('youtube') ? (
              <ReactPlayer
                width="80%"
                height="100%"
                controls={true}
                playing={props.isPlaying}
                id={props.i + props.item.resource}
                url={props.item.resource}
              />
            ) : (
              <video
                src={props.item.resource}
                controls
                muted
                autoPlay
                id={props.i + props.item.resource}
                width="100%"
                preload="auto"
                loop
              >
                {/* <source src={item.resource} type="video/mp4" /> */}
          {/* </video> */}
          {/* )
          ) : ( */}
          <Link to={urlRedirectLink(props?.item)} target={props?.item?.outer_url !== '' ? "_blank" : "_self"} key={props?.item?.product?.id} className="h-100 w-100">
            <img src={props?.item?.portada} alt={props?.item?.product?.titulo || 'ItemSlide'}  className="w-100" />
          </Link>

        </div>
        {/* {props.item.description ? ( //No eliminar
          <div className="containerTextItem">
            <div
              className="textItem"
              dangerouslySetInnerHTML={{ __html: props.item.description }}
            ></div>
          </div>
        ) : null} */}
      </div>
    </>
  );
};

export default ItemSlider;
